import routes from './routes'

export default {
	pageName: "index",
	routes,
}